import type { UploadedImage } from "../api/index.ts";
import { getUploadURL } from "../util/index.ts";

export function useImageUploadProps(
  image: Pick<UploadedImage, "key" | "width" | "height"> | null | undefined,
) {
  if (image) {
    return {
      src: getUploadURL(image),
      height: image.height,
      width: image.width,
    };
  }

  return {};
}
